import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const AddDepartment = () => {
  const navigate=useNavigate()
  const [deans, setDeans] = useState([]);
  const [departmentName,setDepartmentName]=useState()
  const [selectedDean,setSelectedDean]=useState()
  // console.log("The deans are:",selectedDean)
   const fetchDeans = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/university/dean/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        setDeans(res?.data || []);
      } catch (error) {
        console.log("Error while getting profiles", error);
        setDeans([]);
      }
    };
  useEffect(() => {
    fetchDeans();
  }, []);
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!selectedDean) {
    alert("Please select a dean");
    return;
  }

  const data = {
    name: departmentName,
    dean: selectedDean,
  };

  try {
    const res = await axios.post(
      `${BASE_URL}/marketplace/university/department/`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      }
    );

    if (res.status === 201) {
      alert("Department Added Successfully");
      navigate('/marketplace/university/departments')
    }
  } catch (error) {
    console.log("error while add department", error.response);
  }
};

  return (
  <div className="max-w-lg mx-auto">
  <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
    {/* Header */}
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Add Department</h1>
      </div>
      <p className="text-gray-500 text-sm">
        Fill in the details below to add a new department to your organization.
      </p>
    </div>

    {/* Form */}
    <form className="space-y-6" onSubmit={handleSubmit}>
      {/* Department Name */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-semibold text-gray-700">Department Name</label>
        </div>
        <input
          type="text"
          onChange={(e) => setDepartmentName(e.target.value)}
          placeholder="e.g. Computer Science, Mathematics, Physics"
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          required
        />
        <p className="text-xs text-gray-500 mt-2">Enter the full name of the department</p>
      </div>

      {/* Head of Department */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-semibold text-gray-700">Head of Department</label>
        </div>
        <div className="relative">
          <select
            required
            value={selectedDean || ""}
            onChange={(e) => setSelectedDean(e.target.value)}
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 16px center'
            }}
          >
            <option value="" disabled>Select Head of Department</option>
            {deans.map((dean) => (
              <option key={dean.id} value={dean.id}>
                {dean?.profile_data?.name}
              </option>
            ))}
          </select>
        </div>
        <p className="text-xs text-gray-500 mt-2">Choose the faculty member who will lead this department</p>
      </div>

      {/* Submit Button */}
      <div className="pt-4">
        <button
          type="submit"
          className="w-full py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
          </svg>
          Add Department
        </button>
      </div>
    </form>
  </div>
</div>
  );
};

export default AddDepartment;
